<template>
  <div class="">
    <template v-if="!isWebview">
      <h4 class="box-title title">
        <span>{{ $t("dashboard.title.phone_app.ios") }}</span>
        <span> / {{ $t("dashboard.title.phone_app.android") }}</span>
      </h4>
    </template>
    <template v-else>
      <h4 class="box-title title">
        <span v-if="isWebviewIOS">{{$t("dashboard.title.phone.app.ios")}}</span>
        <span v-if="!isWebviewIOS">{{ $t("dashboard.title.phone_app.android") }}</span>
      </h4>
    </template>
			<!-- mobile mode or tablet mode-->
        <div class="box-ct" v-if="!isWebview && (mobileMode || tabletMode)">
				<div class="device-list">
					<div class="row row-narrow">
						<div class="col-md-4">
							<a href="#"  v-open-app-mobile
								:url-universal-link="linksAppList.FX_UNIVERSAL_LINK_URL" :url-app-store = "linksAppList.FX_APPSTORE_URL"
								:url-deep-link="linksAppList.FX_DEEP_LINK_URL" :url-webappstore-link="linksAppList.FX_APPSTORE_URL"
								class="device-list-item btn-red mobile_config_url">
								<i class="fab fa-apple"></i>
								<span class="device-title">{{$t('dashboard.title.fx' )}}</span>
								<span class="device-desc">{{$t('dashboard.title.fx.note' )}}</span>
							</a>
  						</div>
						<div class="col-md-4">
							<a href="#"  v-open-app-mobile
								:url-android-link="linksAppList.FX_OPENAPP_ANDROID_URL" :url-webappstore-link="linksAppList.FX_GOOGLE_PLAY_URL"  class="device-list-item btn-red mobile_config_url">
								<i class="fab fa-android"></i>
								<span class="device-title">{{$t('dashboard.title.fx' )}}</span>
								<span class="device-desc">{{$t('dashboard.title.fx.note' )}}</span>
							</a>
						</div>
 					</div>

					<div class="row row-narrow">
						<div class="col-md-4">
							<a href="#"  v-open-app-mobile
								:url-universal-link="linksAppList.SC_UNIVERSAL_LINK_URL" :url-app-store = "linksAppList.ST_APPSTORE_URL"
								:url-deep-link="linksAppList.SC_DEEP_LINK_URL" :url-webappstore-link="linksAppList.ST_APPSTORE_URL"
								 class="device-list-item btn-blue mobile_config_url">
								<i class="fab fa-apple"></i>
								<span class="device-title">{{$t('dashboard.title.st' )}}</span>
								<span class="device-desc">{{$t('dashboard.title.st.note' )}}</span>
							</a>
  						</div>
  						<div class="col-md-4">
							<a href="#"  v-open-app-mobile			
								:url-android-link="linksAppList.SC_OPENAPP_ANDROID_URL" :url-webappstore-link="linksAppList.ST_GOOGLE_PLAY_URL" class="device-list-item btn-blue mobile_config_url">
								<i class="fab fa-android"></i>
								<span class="device-title">{{$t('dashboard.title.st' )}}</span>
								<span class="device-desc">{{$t('dashboard.title.st.note' )}}</span>
							</a>
 						</div>
 					</div>

					<div class="row row-narrow">
						<div class="col-md-4">
							<a href="#"  v-open-app-mobile
							   :url-universal-link="linksAppList.CRYPT_UNIVERSAL_LINK_URL" :url-app-store = "linksAppList.CRYPT_APPSTORE_URL"
							   :url-deep-link="linksAppList.CRYPT_DEEP_LINK_URL" :url-webappstore-link="linksAppList.CRYPT_APPSTORE_URL"
							   class="device-list-item btn-crypto_app mobile_config_url">
								<i class="fab fa-apple"></i>
								<span class="device-title">{{$t('dashboard.title.crypt' )}}</span>
								<span class="device-desc">{{$t('dashboard.title.crypt.note' )}}</span>
							</a>
						</div>
						<div class="col-md-4">
							<a href="#"  v-open-app-mobile
							   :url-android-link="linksAppList.CRYPT_OPENAPP_ANDROID_URL"
							   :url-webappstore-link="linksAppList.CRYPT_GOOGLE_PLAY_URL" class="device-list-item btn-crypto_app mobile_config_url">
								<i class="fab fa-android"></i>
								<span class="device-title">{{$t('dashboard.title.crypt' )}}</span>
								<span class="device-desc">{{$t('dashboard.title.crypt.note' )}}</span>
							</a>
						</div>
					</div>
					
					<div class="row row-narrow" >
						<div class="col-md-4">
							<a  href="#"  v-open-app-mobile
								:url-android-link="linksAppList.BO_OPENAPP_ANDROID_URL" :url-webappstore-link="linksAppList.BO_GOOGLE_PLAY_URL" class="device-list-item btn-green mobile_config_url">
								<i class="fas fa-mobile-alt"></i>
								<span class="device-title">{{$t('dashboard.title.bo' )}}</span>
								<span class="device-desc">{{$t('dashboard.title.bo.note' )}}</span>
							</a>
						</div>
						<div class="col-md-4" v-if="(!mobileMode && !tabletMode) || tabletMode">
						</div>
					</div>
				</div>
			</div>

			<!-- webview mode -->
			<div class="box-ct" v-if="isWebview">
				<div class="device-list">
					<div class="row row-narrow">
						<div class="col-md-4" v-if="isWebviewIOS">
							<a  href="#"  v-open-app-mobile
								:url-universal-link="linksAppList.FX_UNIVERSAL_LINK_URL" :url-app-store = "linksAppList.FX_APPSTORE_URL"
								:url-deep-link="linksAppList.FX_DEEP_LINK_URL" :url-webappstore-link="linksAppList.FX_APPSTORE_URL"
								class="device-list-item btn-red mobile_config_url">
								<i class="fab fa-apple"></i>
								<span class="device-title">{{$t('dashboard.title.fx' )}}</span>
								<span class="device-desc">{{$t('dashboard.title.fx.note' )}}</span>
							</a>
						</div>
						<div class="col-md-4" v-if="!isWebviewIOS">
							<a href="#"  v-open-app-mobile
							   :url-android-link="linksAppList.FX_OPENAPP_ANDROID_URL" :url-webappstore-link="linksAppList.FX_GOOGLE_PLAY_URL"  class="device-list-item btn-red mobile_config_url">
								<i class="fab fa-android"></i>
								<span class="device-title">{{$t('dashboard.title.fx' )}}</span>
								<span class="device-desc">{{$t('dashboard.title.fx.note' )}}</span>
							</a>
						</div>
					</div>
					<div class="row row-narrow">
						<div class="col-md-4" v-if="isWebviewIOS">
							<a href="#"  v-open-app-mobile
							   :url-universal-link="linksAppList.SC_UNIVERSAL_LINK_URL" :url-app-store = "linksAppList.ST_APPSTORE_URL"
							   :url-deep-link="linksAppList.SC_DEEP_LINK_URL" :url-webappstore-link="linksAppList.ST_APPSTORE_URL"
							   class="device-list-item btn-blue mobile_config_url">
								<i class="fab fa-apple"></i>
								<span class="device-title">{{$t('dashboard.title.st' )}}</span>
								<span class="device-desc">{{$t('dashboard.title.st.note' )}}</span>
							</a>
						</div>
						<div class="col-md-4" v-if="!isWebviewIOS">
							<a href="#"  v-open-app-mobile
							   :url-android-link="linksAppList.SC_OPENAPP_ANDROID_URL" :url-webappstore-link="linksAppList.ST_GOOGLE_PLAY_URL" class="device-list-item btn-blue mobile_config_url">
								<i class="fab fa-android"></i>
								<span class="device-title">{{$t('dashboard.title.st' )}}</span>
								<span class="device-desc">{{$t('dashboard.title.st.note' )}}</span>
							</a>
						</div>
					</div>

					<div class="row row-narrow">
						<div class="col-md-4" v-if="isWebviewIOS">
							<a href="#"  v-open-app-mobile
							   :url-universal-link="linksAppList.CRYPT_UNIVERSAL_LINK_URL" :url-app-store = "linksAppList.CRYPT_APPSTORE_URL"
							   :url-deep-link="linksAppList.CRYPT_DEEP_LINK_URL" :url-webappstore-link="linksAppList.CRYPT_APPSTORE_URL"

							   class="device-list-item btn-crypto_app mobile_config_url">
								<i class="fab fa-apple"></i>
								<span class="device-title">{{$t('dashboard.title.crypt' )}}</span>
								<span class="device-desc">{{$t('dashboard.title.crypt.note' )}}</span>
							</a>
						</div>
						<div class="col-md-4" v-if="!isWebviewIOS">
							<a href="#"  v-open-app-mobile
							   :url-android-link="linksAppList.CRYPT_OPENAPP_ANDROID_URL"
							   :url-webappstore-link="linksAppList.CRYPT_GOOGLE_PLAY_URL" class="device-list-item btn-crypto_app mobile_config_url">
								<i class="fab fa-android"></i>
								<span class="device-title">{{$t('dashboard.title.crypt' )}}</span>
								<span class="device-desc">{{$t('dashboard.title.crypt.note' )}}</span>
							</a>
						</div>
					</div>

					<div class="row row-narrow" >
						<div class="col-md-4">
							<a  href="#"  v-open-app-mobile
								:url-android-link="linksAppList.BO_OPENAPP_ANDROID_URL" :url-webappstore-link="linksAppList.BO_GOOGLE_PLAY_URL" class="device-list-item btn-green mobile_config_url">
								<i class="fas fa-mobile-alt"></i>
								<span class="device-title">{{$t('dashboard.title.bo' )}}</span>
								<span class="device-desc">{{$t('dashboard.title.bo.note' )}}</span>
							</a>
						</div>
						<div class="col-md-4" v-if="(!mobileMode && !tabletMode) || tabletMode">
						</div>
					</div>
				</div>
			</div>
			
			<!-- PC mode -->
			<div class="box-ct" v-if="!mobileMode && !tabletMode">
				<div class="device-list">
					<div class="row row-narrow">
						<div class="col-md-4">
  					<a :href="linksAppList.FX_APPSTORE_URL" class="device-list-item btn-red" target="blank">
 							<i class="fab fa-apple"></i>
 							<span class="device-title">{{$t('dashboard.title.fx' )}}</span>
 							<span class="device-desc">{{$t('dashboard.title.fx.note' )}}</span>
 						</a>
	  				</div>
	  				<div class="col-md-4">
	 						<a :href="linksAppList.FX_GOOGLE_PLAY_URL" class="device-list-item btn-red" target="blank">
	 							<i class="fab fa-android"></i>
	  							<span class="device-title">{{$t('dashboard.title.fx' )}}</span>
	  							<span class="device-desc">{{$t('dashboard.title.fx.note' )}}</span>
	  						</a>
	 					</div>
	 				</div>
					<div class="row row-narrow">
						<div class="col-md-4">
	  					<a :href="linksAppList.ST_APPSTORE_URL" class="device-list-item btn-blue" target="blank">
	 							<i class="fab fa-apple"></i>
	 							<span class="device-title">{{$t('dashboard.title.st' )}}</span>
	 							<span class="device-desc">{{$t('dashboard.title.st.note' )}}</span>
	 						</a>
	  				</div>
	  				<div class="col-md-4">
	 						<a :href="linksAppList.ST_GOOGLE_PLAY_URL" class="device-list-item btn-blue" target="blank">
	 							<i class="fab fa-android"></i>
	  							<span class="device-title">{{$t('dashboard.title.st' )}}</span>
	  							<span class="device-desc">{{$t('dashboard.title.st.note' )}}</span>
	  						</a>
	 					</div>
	 				</div>
					
					<div class="row row-narrow">
						<div class="col-md-4">
							<a :href="linksAppList.CRYPT_APPSTORE_URL" class="device-list-item btn-crypto_app" target="blank">
								<i class="fab fa-apple"></i>
								<span class="device-title">{{$t('dashboard.title.crypt' )}}</span>
								<span class="device-desc">{{$t('dashboard.title.crypt.note' )}}</span>
							</a>
						</div>
						<div class="col-md-4">
							<a :href="linksAppList.CRYPT_GOOGLE_PLAY_URL" class="device-list-item btn-crypto_app" target="blank">
								<i class="fab fa-android"></i>
								<span class="device-title">{{$t('dashboard.title.crypt' )}}</span>
								<span class="device-desc">{{$t('dashboard.title.crypt.note' )}}</span>
							</a>
						</div>
					</div>
					
				 	<div class="row row-narrow">
	  					<div class="col-md-4">
							<h5 class="box-content-title">{{$t('dashboard.title.bo.web' )}}</h5>
	 						<a :href="linksAppList.BO_GOOGLE_PLAY_URL" class="device-list-item btn-green" target="blank">
	 							<i class="fas fa-mobile-alt"></i>
	 							<span class="device-title">{{$t('dashboard.title.bo' )}}</span>
	 							<span class="device-desc">{{ $t('dashboard.title.bo.note' )}}</span>
	 						</a>
	 					</div>

						<!-- <div class="col-md-4" v-if="!responsiveMode">
						</div> -->
	 				</div>
				</div>
			</div>
		</div>
</template>

<script>
    /**
     * @author HungNS
     */

import {createNamespacedHelpers} from "vuex";

const { mapGetters: mapHeaderGetters } = createNamespacedHelpers("header");
export default {
  computed: {
    ...mapHeaderGetters(["linksAppList"]),
  },
};
</script>

<style>
.fab.fa-apple, .fab.fa-android, .fas.fa-mobile-alt {
  height: auto !important;
  text-align: center !important;
  display: flex;
  justify-content: center;
  align-items: center;
}

</style>